<div class="pr-xlarge-t mr-large-b">
  @if (links().length) {
    <fcom-quick-links [links]="links()" [showBorder]="false" [showCompact]="true" (clickLink)="clickLink($event)" />
  }
</div>
